import React, { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import BannerSingle from '../../../BannerSingle';
import PageDescriptionPlano from '../../../PageDescription/Planos/index';
import Lgpd from '../../../Lgpd';
import PatrimonioPlano from '../../../Numeros/Planos';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';

class DescricaoPage extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"plano-b"} page={'plano-b'} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescriptionPlano certificado={"/DOCS/Publicacoes/Certificados/Plano%20B/Certificado%20do%20Participante%20-%20Plano%20B.pdf"}  page={'plano-b'} /></ErrorBoundary>

					{/* Content page */}
					<ErrorBoundary><PatrimonioPlano url={"/ObterDescricaoPlanoB"} urlTable={"/ObterDescricaoPlanoB"}  page={'plano-b'}/></ErrorBoundary>
					{/* <ErrorBoundary><PatrimonioPlano  url={"/ObterDescricaoPlanoB"} urlTable={"/ObterDescricaoPlanoB"} htmlPart={

						<div className="col-md-10">
							<hr />

							<h3>Percentuais de contribuição</h3>
							<p>
								Níveis de contribuição (%):  50, 75, 90, 100, 125, 150  ou 200 de uma tabela básica aplicada à remuneração do participante. Obs.: a patrocinadora acompanha os mesmos percentuais de contribuição até o teto de 100%. O percentual de contribuição pode ser alterado nos meses de fevereiro, maio, agosto e novembro.
							</p>
							<br />
							<br />

							<h3>Perfis de investimento</h3>
							<p>
								Ultraconservador <br />
								Conservador <br />
								Moderado <br />
								Agressivo
							</p>

							<br />
							<br />

							<h3>Critérios para requerer benefício</h3>
							<ul className="mb-0">
								<li> Estar desligado da patrocinadora; </li>
								<li> Ter pelo menos 10 anos de vínculo com o Plano; </li>
								<li> Ter contribuído para a Previdência Social durante no mínimo 25 anos, se for mulher, ou 30 anos, se for homem ou estar aposentado pelo INSS. </li>
							</ul>

							<hr />

							<h3> Modalidades de benefícios </h3>
							<br /> <br />
							<h4> MAT (Melhoria de Aposentadoria por Tempo de Serviço, Especial ou Idade)  </h4>
							<p>
							Vitalícia: benefício pago até o final da vida do participante. É calculado conforme o saldo acumulado na Conta de Aposentadoria do participante, a sua expectativa de vida e a rentabilidade esperada dos recursos. Cabe destacar que este tipo de benefício não está disponível aos participantes que se filiaram após 31 de maio de 2018. 
							</p>
							<br />
							<p> <h4> MAT Temporária em Prazo Certo  </h4> Benefício pago ao participante durante 10, 15 ou 20 anos. É uma renda mensal calculada com base no saldo acumulado da conta de aposentadoria, o prazo escolhido e a rentabilidade esperada para os recursos. O valor é reajustado anualmente pelo IPCA-IBGE.</p>

							<br /> <br />
							<h4> MAT Temporária em Valor Variável (MAT "em Cotas")  </h4>
							<p>
							Nesta modalidade, o participante escolhe o valor mensal de sua renda entre 0,2% e 1,0% do saldo da conta de aposentadoria. O saldo de conta remanescente é corrigido mensalmente pela rentabilidade dos benefícios concedidos. Em caso de falecimento do participante assistido, o saldo remanescente da conta será dividido entre os beneficiários inscritos, sendo pago de acordo com a escolha do beneficiário, isto é, em parcela única ou em forma do último percentual percebido pelo titular. Caso não haja beneficiário, o saldo remanescente será pago em parcela única ao espólio. 
							</p>

							<br /> <br />
							<h4> MAT Conjugada </h4>
							<p>
							Idealizada para que o participante tenha a opção de requerer o benefício, sendo parte em renda temporária em valor variável (cotas) e parte em renda vitalícia. É importante destacar que pelo menos 50% do saldo de conta deverá ser convertido em renda vitalícia. Os percentuais escolhidos no requerimento do benefício conjugado não poderão ser alterados depois.
							</p>
							
							<br /> <br />
							<h4> MAI Melhoria de Aposentadoria por Invalidez </h4>
							<p>
							Benefício concedido pelo plano ao participante que se aposenta por invalidez e cumpre os demais requisitos regulamentares, entre os quais, perícia da Forluz.
							</p>

							<br /> <br />
							<h4> RCM (Renda Continuada por Morte) </h4>
							<p className="mb-0">
							Benefício pago pelo plano ao beneficiário inscrito do participante falecido. Em caso de falecimento do participante ainda na fase ativa, a RCM é calculada com base na média das doze últimas remunerações do participante sobre as quais incidiu contribuição. 
							</p>

							<hr />

							<h3> Institutos </h3>
							<p> Se o participante se desligar da patrocinadora e não tiver cumprido os requisitos exigidos para requerer benefício da Forluz, pode optar por uma das quatro alternativas denominadas "institutos" abaixo:</p>

							<br />

							<div className="desc">
								<p>
									<strong> Resgate: </strong> poderá resgatar a totalidade da conta individual, juntamente com um percentual da conta patronal, que dependerá do tempo de vínculo empregatício.
								</p>
								<br />
								<p>
									<strong> Portabilidade: </strong> transferência do valor equivalente ao resgate para outro plano previdenciário de 100% das contribuições vertidas pelo participante.
								</p>
								<br />
								<p>
									<strong> Autopatrocínio: </strong> manutenção no plano por meio do compromisso mensal de pagar as contribuições individual e patronal que eram realizadas mensalmente enquanto ativo, bem como a contribuição destinada à cobertura das despesas de natureza administrativa.
								</p>
								<br />
								<p>
									<strong> BPD (Benefício Proporcional Diferido): </strong> permanência no plano, pagando apenas a contribuição destinada à cobertura das despesas de natureza administrativa. O saldo de conta continua tendo a rentabilidade de acordo com o perfil de investimento escolhido pelo participante.
								</p>
							</div>

						</div>

					} /></ErrorBoundary> */}

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default DescricaoPage;